import React, { useState, useMemo } from 'react';
import { Card, Table, Form, Row, Col, Badge, ProgressBar, Spinner, Button } from 'react-bootstrap';
import { useQuery } from 'react-query';
import { LICHHOCLIENTUC_API } from '../../../../utils/apiUrl';
import { Get } from '../../../../utils/httpProvider';

const ThongKeDiemDanhLienTuc = ({ lopId, lopDetail }) => {
    const [searchKeyword, setSearchKeyword] = useState('');
    const [filterExamStatus, setFilterExamStatus] = useState('ALL'); // 'ALL' | '1' | '2' | '3'

    // Fetch dữ liệu thống kê
    const { data: summaryData, isLoading, refetch } = useQuery(
        ['thongKeDiemDanhLienTuc', lopId, searchKeyword],
        async () => {
            let url = `${LICHHOCLIENTUC_API.GET_THONG_KE_DIEM_DANH}/${lopId}`;
            if (searchKeyword) {
                url += `?keyword=${encodeURIComponent(searchKeyword)}`;
            }
            const res = await Get(url);
            return res?.data || res || {};
        },
        {
            enabled: !!lopId,
            keepPreviousData: true
        }
    );

    const items = summaryData?.items?.$values || summaryData?.items || [];

    // Filter items theo Trạng thái xét thi trên frontend
    const filteredItems = useMemo(() => {
        if (filterExamStatus === 'ALL') return items;
        const targetStatus = Number(filterExamStatus);
        return items.filter(x => x.trangThaiXetThi === targetStatus);
    }, [items, filterExamStatus]);

    return (
        <div className="thong-ke-diem-danh-lien-tuc">
            {/* HEADER THÔNG TIN KHOA PHỤ TRÁCH & LỚP */}
            {lopDetail && (
                <div className="p-3 rounded mb-3 bg-white border shadow-sm d-flex flex-wrap align-items-center justify-content-between" style={{ borderRadius: '12px' }}>
                    <div className="d-flex align-items-center mb-2 mb-md-0">
                        <div className="p-2 rounded mr-3 shadow-xs" style={{ backgroundColor: '#e0f2fe', color: '#0284c7' }}>
                            <i className="fas fa-hospital-alt fa-2x"></i>
                        </div>
                        <div>
                            <div className="text-muted small font-weight-bold text-uppercase">Khoa chuyên môn phụ trách</div>
                            <h5 className="font-weight-bold text-dark mb-0">{lopDetail.khoaDeXuatTen || "Khoa chuyên môn"}</h5>
                        </div>
                    </div>
                    <div className="d-flex flex-wrap align-items-center small text-muted" style={{ gap: '16px' }}>
                        {lopDetail.soQuyetDinh && (
                            <span><i className="fas fa-file-signature text-secondary mr-1"></i> Số QĐ: <strong>{lopDetail.soQuyetDinh}</strong></span>
                        )}
                        {lopDetail.ngayKhaiGiang && (
                            <span><i className="fas fa-calendar-alt text-secondary mr-1"></i> Khai giảng: <strong>{new Date(lopDetail.ngayKhaiGiang).toLocaleDateString('vi-VN')}</strong></span>
                        )}
                        {lopDetail.ngayBeGiang && (
                            <span><i className="fas fa-calendar-check text-secondary mr-1"></i> Bế giảng: <strong>{new Date(lopDetail.ngayBeGiang).toLocaleDateString('vi-VN')}</strong></span>
                        )}
                    </div>
                </div>
            )}

            {/* KHỐI 1: KPI CARDS */}
            <Row className="mb-4" style={{ rowGap: '12px' }}>
                <Col xl={3} lg={6} sm={6}>
                    <Card className="border-0 shadow-sm h-100" style={{ borderRadius: '12px', background: 'linear-gradient(135deg, #e0f2fe 0%, #f0f9ff 100%)', borderLeft: '5px solid #0284c7' }}>
                        <Card.Body className="p-3 d-flex align-items-center justify-content-between">
                            <div>
                                <div className="text-muted small font-weight-bold text-uppercase">Tổng học viên</div>
                                <div className="h3 mb-0 font-weight-bold" style={{ color: '#0369a1' }}>
                                    {summaryData?.tongHocVien ?? 0}
                                </div>
                                <small className="text-secondary">Trong lớp liên tục</small>
                            </div>
                            <div className="p-3 rounded-circle bg-white shadow-xs">
                                <i className="fas fa-users fa-2x" style={{ color: '#0284c7' }}></i>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>

                <Col xl={2} lg={6} sm={6}>
                    <Card className="border-0 shadow-sm h-100" style={{ borderRadius: '12px', background: 'linear-gradient(135deg, #f3e8ff 0%, #faf5ff 100%)', borderLeft: '5px solid #9333ea' }}>
                        <Card.Body className="p-3 d-flex align-items-center justify-content-between">
                            <div>
                                <div className="text-muted small font-weight-bold text-uppercase">Buổi tổ chức</div>
                                <div className="h3 mb-0 font-weight-bold" style={{ color: '#7e22ce' }}>
                                    {summaryData?.tongBuoiHocToChuc ?? 0}
                                </div>
                                <small className="text-secondary">Buổi học toàn khóa</small>
                            </div>
                            <div className="p-3 rounded-circle bg-white shadow-xs">
                                <i className="fas fa-calendar-alt fa-2x" style={{ color: '#9333ea' }}></i>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>

                <Col xl={2} lg={4} sm={4}>
                    <Card className="border-0 shadow-sm h-100" style={{ borderRadius: '12px', background: 'linear-gradient(135deg, #e0e7ff 0%, #eef2ff 100%)', borderLeft: '5px solid #4f46e5' }}>
                        <Card.Body className="p-3">
                            <div className="text-muted small font-weight-bold text-uppercase">Chuyên cần TB</div>
                            <div className="h3 mb-0 font-weight-bold" style={{ color: '#4338ca' }}>
                                {summaryData?.tyLeChuyenCanTrungBinh ?? 0}%
                            </div>
                            <ProgressBar 
                                now={summaryData?.tyLeChuyenCanTrungBinh ?? 0} 
                                variant={summaryData?.tyLeChuyenCanTrungBinh >= 80 ? 'success' : 'warning'} 
                                style={{ height: '5px', marginTop: '8px' }} 
                            />
                        </Card.Body>
                    </Card>
                </Col>

                <Col xl={3} lg={4} sm={4}>
                    <Card className="border-0 shadow-sm h-100" style={{ borderRadius: '12px', background: 'linear-gradient(135deg, #dcfce7 0%, #f0fdf4 100%)', borderLeft: '5px solid #16a34a' }}>
                        <Card.Body className="p-3 d-flex align-items-center justify-content-between">
                            <div>
                                <div className="text-muted small font-weight-bold text-uppercase">Đủ ĐK thi (≥80%)</div>
                                <div className="h3 mb-0 font-weight-bold" style={{ color: '#15803d' }}>
                                    {summaryData?.soDuDieuKienThi ?? 0}
                                </div>
                                <small className="text-success font-weight-bold">Đạt điều kiện dự thi</small>
                            </div>
                            <div className="p-3 rounded-circle bg-white shadow-xs">
                                <i className="fas fa-check-circle fa-2x" style={{ color: '#16a34a' }}></i>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>

                <Col xl={2} lg={4} sm={4}>
                    <Card className="border-0 shadow-sm h-100" style={{ borderRadius: '12px', background: 'linear-gradient(135deg, #fee2e2 0%, #fef2f2 100%)', borderLeft: '5px solid #dc2626' }}>
                        <Card.Body className="p-3">
                            <div className="text-muted small font-weight-bold text-uppercase">Cảnh báo / Cấm thi</div>
                            <div className="h4 mb-0 font-weight-bold" style={{ color: '#b91c1c' }}>
                                <span className="text-warning mr-1">{summaryData?.soCanhBaoChuyenCan ?? 0}</span>
                                / <span className="text-danger ml-1">{summaryData?.soKhongDuDieuKienThi ?? 0}</span>
                            </div>
                            <small className="text-muted">Cảnh báo / Cấm thi</small>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            {/* KHỐI 2: TOOLBAR LỌC & TÌM KIẾM */}
            <Card className="shadow-sm border-0 mb-3" style={{ borderRadius: '12px' }}>
                <Card.Body className="py-2 px-3">
                    <Row className="align-items-center">
                        <Col xl={5} lg={5} md={6} className="my-1">
                            <div className="d-flex align-items-center">
                                <i className="fas fa-search text-muted mr-2"></i>
                                <Form.Control
                                    size="sm"
                                    type="text"
                                    placeholder="Tìm theo tên học viên, đơn vị công tác..."
                                    value={searchKeyword}
                                    onChange={(e) => setSearchKeyword(e.target.value)}
                                    style={{ borderRadius: '8px', border: '1px solid #cbd5e1' }}
                                />
                            </div>
                        </Col>

                        <Col xl={5} lg={5} md={6} className="my-1">
                            <div className="btn-group btn-group-sm w-100" role="group">
                                <Button
                                    variant={filterExamStatus === 'ALL' ? 'primary' : 'outline-secondary'}
                                    style={{ borderRadius: '8px 0 0 8px', fontSize: '12px' }}
                                    onClick={() => setFilterExamStatus('ALL')}
                                >
                                    Tất cả ({items.length})
                                </Button>
                                <Button
                                    variant={filterExamStatus === '1' ? 'success' : 'outline-secondary'}
                                    style={{ fontSize: '12px' }}
                                    onClick={() => setFilterExamStatus('1')}
                                >
                                    Đủ ĐK ({items.filter(x => x.trangThaiXetThi === 1).length})
                                </Button>
                                <Button
                                    variant={filterExamStatus === '2' ? 'warning' : 'outline-secondary'}
                                    style={{ fontSize: '12px' }}
                                    onClick={() => setFilterExamStatus('2')}
                                >
                                    Cảnh báo ({items.filter(x => x.trangThaiXetThi === 2).length})
                                </Button>
                                <Button
                                    variant={filterExamStatus === '3' ? 'danger' : 'outline-secondary'}
                                    style={{ borderRadius: '0 8px 8px 0', fontSize: '12px' }}
                                    onClick={() => setFilterExamStatus('3')}
                                >
                                    Cấm thi ({items.filter(x => x.trangThaiXetThi === 3).length})
                                </Button>
                            </div>
                        </Col>

                        <Col xl={2} lg={2} md={12} className="my-1 text-right">
                            <Button
                                variant="outline-primary"
                                size="sm"
                                style={{ borderRadius: '8px', fontSize: '12px' }}
                                onClick={() => refetch()}
                                title="Tải lại dữ liệu"
                            >
                                <i className="fas fa-sync-alt mr-1"></i> Làm mới
                            </Button>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>

            {/* KHỐI 3: BẢNG MATRIX THỐNG KÊ */}
            <Card className="shadow-sm border-0" style={{ borderRadius: '12px', overflow: 'hidden' }}>
                <div className="table-responsive" style={{ maxHeight: 'calc(100vh - 350px)', overflowY: 'auto' }}>
                    <Table hover className="mb-0 align-middle" style={{ minWidth: 900 }}>
                        <thead style={{ backgroundColor: '#f8fafc', position: 'sticky', top: 0, zIndex: 2, boxShadow: '0 1px 2px rgba(0,0,0,0.05)' }}>
                            <tr style={{ color: '#475569', fontSize: '12px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                <th style={{ width: 50, textAlign: 'center' }}>STT</th>
                                <th style={{ minWidth: 220 }}>Học viên</th>
                                <th style={{ width: 100, textAlign: 'center' }}>Tổng buổi</th>
                                <th style={{ width: 100, textAlign: 'center', color: '#15803d' }}>Có mặt</th>
                                <th style={{ width: 100, textAlign: 'center', color: '#b45309' }}>Vắng CP</th>
                                <th style={{ width: 100, textAlign: 'center', color: '#b91c1c' }}>Vắng KP</th>
                                <th style={{ width: 160, textAlign: 'center' }}>% Chuyên cần</th>
                                <th style={{ width: 160, textAlign: 'center' }}>Xét điều kiện thi</th>
                            </tr>
                        </thead>
                        <tbody>
                            {isLoading ? (
                                <tr>
                                    <td colSpan={8} className="text-center py-5">
                                        <Spinner animation="border" variant="primary" size="sm" className="mr-2" />
                                        <span className="text-muted">Đang tải số liệu thống kê điểm danh...</span>
                                    </td>
                                </tr>
                            ) : filteredItems.length === 0 ? (
                                <tr>
                                    <td colSpan={8} className="text-center py-5">
                                        <div className="text-muted">
                                            <i className="fas fa-inbox fa-3x mb-3 text-secondary" style={{ opacity: 0.5 }}></i>
                                            <p className="mb-0">Không tìm thấy bản ghi thống kê điểm danh phù hợp.</p>
                                        </div>
                                    </td>
                                </tr>
                            ) : (
                                filteredItems.map((row, idx) => {
                                    const progressVariant = row.tyLeChuyenCan >= 80 ? 'success' : row.tyLeChuyenCan >= 70 ? 'warning' : 'danger';

                                    return (
                                        <tr key={`${row.hoSoTuyenSinhId}-${idx}`} style={{ fontSize: '13px' }}>
                                            <td className="text-center text-muted font-weight-bold" style={{ verticalAlign: 'middle' }}>
                                                {idx + 1}
                                            </td>

                                            <td style={{ verticalAlign: 'middle' }}>
                                                <div className="font-weight-bold text-dark">{row.hocVienTen}</div>
                                                <div className="small text-muted">
                                                    {row.ngaySinh && <span>NS: {row.ngaySinh}</span>}
                                                    {row.donViCongTac && <span> • {row.donViCongTac}</span>}
                                                </div>
                                            </td>

                                            <td className="text-center font-weight-bold" style={{ verticalAlign: 'middle', color: '#334155' }}>
                                                {row.tongBuoiHoc} buổi
                                            </td>

                                            <td className="text-center font-weight-bold" style={{ verticalAlign: 'middle', color: '#16a34a' }}>
                                                {row.soBuoiCoMat}
                                            </td>

                                            <td className="text-center font-weight-bold" style={{ verticalAlign: 'middle', color: '#d97706' }}>
                                                {row.soBuoiVangCoPhep > 0 ? row.soBuoiVangCoPhep : '-'}
                                            </td>

                                            <td className="text-center font-weight-bold" style={{ verticalAlign: 'middle' }}>
                                                {row.soBuoiVangKhongPhep > 0 ? (
                                                    <span className="badge badge-danger px-2 py-1" style={{ fontSize: '12px' }}>
                                                        <i className="fas fa-exclamation-triangle mr-1"></i>
                                                        {row.soBuoiVangKhongPhep}
                                                    </span>
                                                ) : (
                                                    <span className="text-muted">-</span>
                                                )}
                                            </td>

                                            <td style={{ verticalAlign: 'middle' }}>
                                                <div className="d-flex align-items-center justify-content-between mb-1">
                                                    <span className="small font-weight-bold" style={{ color: '#475569' }}>
                                                        {row.tyLeChuyenCan}%
                                                    </span>
                                                </div>
                                                <ProgressBar 
                                                    now={Math.min(100, row.tyLeChuyenCan)} 
                                                    variant={progressVariant} 
                                                    style={{ height: '6px', borderRadius: '3px' }} 
                                                />
                                            </td>

                                            <td className="text-center" style={{ verticalAlign: 'middle' }}>
                                                {row.trangThaiXetThi === 1 && (
                                                    <Badge 
                                                        variant="success" 
                                                        className="px-2 py-1"
                                                        style={{ backgroundColor: '#dcfce7', color: '#15803d', border: '1px solid #86efac', fontSize: '12px', fontWeight: '600' }}
                                                    >
                                                        <i className="fas fa-check-circle mr-1"></i> Đủ ĐK dự thi
                                                    </Badge>
                                                )}
                                                {row.trangThaiXetThi === 2 && (
                                                    <Badge 
                                                        variant="warning" 
                                                        className="px-2 py-1"
                                                        style={{ backgroundColor: '#fef3c7', color: '#92400e', border: '1px solid #fcd34d', fontSize: '12px', fontWeight: '600' }}
                                                    >
                                                        <i className="fas fa-exclamation-circle mr-1"></i> Cảnh báo (70-79%)
                                                    </Badge>
                                                )}
                                                {row.trangThaiXetThi === 3 && (
                                                    <Badge 
                                                        variant="danger" 
                                                        className="px-2 py-1"
                                                        style={{ backgroundColor: '#fee2e2', color: '#b91c1c', border: '1px solid #fca5a5', fontSize: '12px', fontWeight: '600' }}
                                                    >
                                                        <i className="fas fa-ban mr-1"></i> Cấm thi (&lt;70%)
                                                    </Badge>
                                                )}
                                            </td>
                                        </tr>
                                    );
                                })
                            )}
                        </tbody>
                    </Table>
                </div>
            </Card>
        </div>
    );
};

export default ThongKeDiemDanhLienTuc;
